import axios, { AxiosResponse } from 'axios';
import authHeader from '@/services/auth-header';
import { SALES_CATALOG_ENDPOINT } from '@/constants/endpoints';
import ServiceCatalogItemDTO, { AddServiceCatalogItemPayload, UpdateServiceCatalogPricePayload } from '@/dto/sales/catalog/ServiceCatalogItemDTO';

export default new class ServiceCatalogService {
    public getCatalog(): Promise<AxiosResponse<Array<ServiceCatalogItemDTO>>> {
        return axios.get<Array<ServiceCatalogItemDTO>>(SALES_CATALOG_ENDPOINT, { headers: authHeader() });
    }

    public addItem(payload: AddServiceCatalogItemPayload): Promise<AxiosResponse<ServiceCatalogItemDTO>> {
        return axios.post<ServiceCatalogItemDTO>(SALES_CATALOG_ENDPOINT, payload, { headers: authHeader() });
    }

    public updatePrice(id: number, payload: UpdateServiceCatalogPricePayload): Promise<AxiosResponse<ServiceCatalogItemDTO>> {
        return axios.post<ServiceCatalogItemDTO>(`${SALES_CATALOG_ENDPOINT}/${id}/price`, payload, { headers: authHeader() });
    }
}
